export default __webpack_public_path__ + "static/media/bag.c049303c.png";